import React, { useState } from 'react';

const SupplyCategoryForm = ({ onSubmit }) => {
  const [name, setName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ name });
    setName('');
  };

  return (
    <div className="bg-[#F9EFD7] p-4 rounded-lg shadow mb-4">
      <h3 className="text-lg font-semibold text-[#3F1907] mb-3">Agregar Categoría de Insumo</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Nombre de la categoría de insumo"
            className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-[#58735A] hover:bg-[#3F1907] text-[#F9EFD7] font-medium py-2 px-4 rounded-md transition duration-200"
        >
          Guardar
        </button>
      </form>
    </div>
  );
};

export default SupplyCategoryForm;